import React, { useEffect, useState } from 'react';
import { isEmpty, trim } from 'lodash';
import { t, Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { Grid, H3, P, TextField } from '@decisiv/ui-components';
import RadioGroup from '@decisiv/ui-components/lib/components/RadioGroup';
import SectionRow from '../../components/SectionRow';
import { MAX_CACHE_TTL_LENGTH } from '../../common/constants/maxLengthValues';

export default function CacheSettings({
  handleForm,
  triggerTypeHttpRequest,
  setCreateBtnDisabledStatus,
  errors,
  setErrors,
}) {
  const [showField, setShowField] = useState(false);

  const handleShowField = () => {
    setShowField(!showField);
  };

  const validateCacheTTL = (e) => {
    if (isEmpty(trim(e.target.value))) {
      setErrors({ ...errors, cache_ttl: t`Can't be blank` });
      setCreateBtnDisabledStatus(true);
    } else if (Number(e.target.value) < 300) {
      setErrors({
        ...errors,
        cache_ttl: t`Can't be less than 300 seconds`,
      });
      setCreateBtnDisabledStatus(true);
    } else {
      setErrors({ ...errors, cache_ttl: '' });
    }
  };

  const handleChange = (e) => {
    if (e.target.value.length > MAX_CACHE_TTL_LENGTH) {
      e.target.value = e.target.value.slice(0, MAX_CACHE_TTL_LENGTH);
    }
    handleForm({ event: e });
  };

  useEffect(() => {
    // eslint-disable-next-line
  }, [triggerTypeHttpRequest]);

  return triggerTypeHttpRequest ? (
    <SectionRow>
      <Grid.Column padding={0} span="3">
        <H3>
          <Trans>Cache Settings</Trans>
        </H3>
      </Grid.Column>
      <Grid.Column padding={0}>
        <P shade={1} size="small" marginBottom={1}>
          <Trans>
            Enable caching for some integrations which result does not change
            often, you can define how long integration gonna be cached in
            seconds
          </Trans>
        </P>
        <RadioGroup
          name="cache_enabled"
          size="normal"
          items={[
            { label: t`Yes`, value: 'true' },
            { label: t`No`, value: 'false' },
          ]}
          onChange={(e) => {
            handleForm({ event: e });
            handleShowField();
          }}
          defaultValue="false"
          onClick={(event) => {
            event.stopPropagation();
          }}
        />
        <br />
        {showField ? (
          <TextField
            label={t`Cache TTL in seconds`}
            name={t`cache_ttl`}
            required
            type="number"
            onChange={handleChange}
            onBlur={validateCacheTTL}
            warningMessage={errors.cache_ttl}
            defaultValue={300}
          />
        ) : null}
      </Grid.Column>
    </SectionRow>
  ) : (
    ''
  );
}
CacheSettings.propTypes = {
  handleForm: PropTypes.func.isRequired,
  triggerTypeHttpRequest: PropTypes.bool.isRequired,
  setCreateBtnDisabledStatus: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  setErrors: PropTypes.func.isRequired,
};
